import React from 'react';

const Testimonials = ({ data }) => {
   if (!data) return null;

   const getInitials = (name) => {
      if (!name) return 'N';
      const cleanName = name.split('-')[0].trim();
      const parts = cleanName.split(' ').filter(Boolean);
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return cleanName.substring(0, 2).toUpperCase();
   };

   const testimonials = data.testimonials.map((testimonial) => {
      return (
         <li key={testimonial.user}>
            <blockquote>
               <p>{testimonial.text}</p>
               <div className="testimonial-meta">
                  <cite>{testimonial.user}</cite>
                  <div className="testimonial-image">
                     <img
                        src={`/images/linkedin/${testimonial.image}.jpeg`}
                        alt={testimonial.user}
                        className="testimonial-pic"
                        onError={(e) => {
                           e.target.style.display = 'none';
                           if (e.target.nextSibling) {
                              e.target.nextSibling.style.display = 'flex';
                           }
                        }}
                     />
                     <div
                        className="testimonial-avatar-fallback"
                        style={{ display: 'none' }}
                     >
                        {getInitials(testimonial.user)}
                     </div>
                  </div>
               </div>
            </blockquote>
            <hr className="testimonial-divider" />
         </li>
      );
   });

   return (
      <section id="testimonials">
         <div className="text-container">
            <div className="row">
               <div className="two columns header-col">
                  <h1>
                     <span>Client Testimonials</span>
                  </h1>
               </div>

               <div className="ten columns flex-container">
                  <ul className="slides">{testimonials}</ul>
               </div>
            </div>
         </div>
      </section>
   );
};

export default Testimonials;
